/**
 * Component Registry for Weidner Apartment Homes Theme
 * 
 * Extends the base aster theme registry with Weidner Apartment Homes specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-aster/registry';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HeroSolidBG } from './components/HeroSolidBG';
import { HyperlocalHero } from './components/HyperlocalHero';
import { FloorplansList } from './components/FloorplansList';
import { FloorPlansIntro } from './components/FloorPlansIntro';
import { Footer } from './components/Footer';
import { ConvenienceCallout } from './components/ConvenienceCallout';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';
import { QualifyingCriteria } from './components/QualifyingCriteria';
import { PhotoSlider } from './components/PhotoSlider';
import { GalleryApartments } from './components/GalleryApartments';
import { GalleryCommunity } from './components/GalleryCommunity';
import { Deals } from './components/Deals';
import { DallasMavericksGames } from './components/DallasMavericksGames';
import { VirtualTourEmbed } from './components/VirtualTourEmbed';
import { WhiteStripe } from './components/WhiteStripe';
import { AmenitiesList } from './components/AmenitiesList';
import { AmenitiesSummary } from './components/AmenitiesSummary';
import { Testimonials } from './components/Testimonials';
import { PropertyOverview } from './components/PropertyOverview';
import { InteractiveMapSection } from './components/InteractiveMapSection';
import { LetsConnect } from './components/LetsConnect';
import { PetPolicyInfo } from './components/PetPolicyInfo';

/**
 * Weidner Apartment Homes specific component overrides.
 * These components have been customized for the Weidner Apartment Homes brand.
 */
const weidnerapartmenthomesOverrides: Partial<ComponentRegistry> = {
  Header,
  Hero,
  HeroSolidBG,
  HyperlocalHero,
  FloorplansList,
  FloorPlansIntro,
  Footer,
  ConvenienceCallout,
  SpecialOfferBanner,
  QualifyingCriteria,
  PhotoSlider,
  GalleryApartments,
  GalleryCommunity,
  Deals,
  DallasMavericksGames,
  VirtualTourEmbed,
  WhiteStripe,
  AmenitiesList,
  AmenitiesSummary,
  Testimonials,
  PropertyOverview,
  InteractiveMapSection,
  LetsConnect,
  PetPolicyInfo,
};

/**
 * Final merged registry for Weidner Apartment Homes properties.
 * Inherits all components from the aster theme, with Weidner Apartment Homes overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...weidnerapartmenthomesOverrides,
};

export default registry;
